import React from 'react';
import Script from 'next/script'

const Saam = () => {

    return (
        <Script crossOrigin strategy="lazyOnload" src="https://prod.cms.col.movistar.es/static/js/sa2m/sa2m.min.js" />
    )
}



export default Saam;